import { ACCESS_TOKEN, IS_AUTHENTICATED, IS_DATA_RECEIVED } from '../stateManagment/gameState';
import { PostMessage, PostMessageListenerMessages } from '../core/constats';

export class IframeService {
  openDeposit = (
    obj = {
      action: 'openSlider',
      tab: 'deposit',
    },
    target = '*'
  ) => {
    window.top.postMessage(obj, target);
  };

  logout = (key = 'logout', target = '*') => {
    window.parent.postMessage(key, target);
  };

  reloadFrameForRealMoney = (
    obj = {
      action: 'togglePlayMode',
      gameId: '131315',
    },
    target = '*'
  ) => {
    window.top.postMessage(obj, target);
  };

  redirection = (type = null, target = '*') => {
    if (type) {
      window.parent.postMessage('redirectLogin', target);
    } else {
      window.parent.postMessage('redirectHome', target);
    }
  };

  reloadFrame = (target = '*') => {
    window.parent.postMessage('reload', target);
  };

  isInIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  sendLoadedState = (target = '*') => {
    window.parent.postMessage('pgGameLoaded', target);
  };

   setPostMessageListener (messageParams) {
    if (!this.isInIframe()) {
      IS_DATA_RECEIVED.next(true);
    } else {
      window.addEventListener('message', (message) => {
        if (message.data && message.data.name === PostMessageListenerMessages.AuthInfoUpdate) {
          const { accessToken, isAuthenticated } = message.data;
          IS_AUTHENTICATED.next(isAuthenticated);
          ACCESS_TOKEN.next(accessToken);
          IS_DATA_RECEIVED.next(true);
        }

        if (messageParams && messageParams.length) {
          messageParams.forEach(({ name, callback }) => {
            if (message.data && message.data.name === name) {
              callback(message.data);
            }
          });
        }
      });
    }
  }

  sendGetAuthInfo()  {
    this.sendParentMessage(PostMessage.PgGetAuthInfo);
  }

  sendParentMessage(message, targetOrigin = '*', transfer) {
  window.parent.postMessage(message, targetOrigin, transfer);
}
}

export const iframeService = new IframeService();
